module.exports = __webpack_public_path__ + "assets/images/10R.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/10R.png
// module id = 1287
// module chunks = 1